<template lang="pug">
b-modal#addNews(
  ref="addNews"
  :title="$t('ui.combine.add_news')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row.mb-3
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.slug')").mb-0
          DebounceInput(
            size="sm"
            ref="slug"
            type="text"
            :dirty="$v.slug.$dirty"
            :error="$v.slug.$error"
            v-model.trim.lazy="$v.slug.$model"
            :disabled="loading"
          )
          small.form-text.text-muted {{ $t('message.info_slug') }}
          ValidateResult(:value="$v.slug" :name="$t('ui.slug')")
      div.col-sm-12.col-md-4.col-lg-4
        b-form-group(:label="$t('ui.default_order')").mb-2
          div.d-flex
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="default_order")
              span.custom-switch-indicator
          ValidateResult(:value="$v.default_order" :name="$t('ui.default_order')")
      div.col-sm-12.col-md-4.col-lg-4(v-if="default_order == false")
        b-form-group(:label="$t('ui.item_order')").mb-0
          CMSBannerCount(
            :operatorID="operatorID"
            ref="item_order"
            size="sm"
            required
            type="array"
            :dirty="$v.item_order.$dirty"
            :error="$v.item_order.$error"
            v-model.trim.lazy="$v.item_order.$model"
            bType="news"
            :disabled="loading"
            :viewType="viewType"
          )
          ValidateResult(:value="$v.item_order" :name="$t('ui.item_order')")

    .row
      .col-12
        ul#editorTab.nav.nav-tabs(role='tablist')
          li.nav-item
            a#enNewsAdd-tab.nav-link(data-toggle='tab' href='#enNewsAdd-content' role='tab' aria-controls='enNewsAdd' aria-selected='false' @click="setTab('en')" :class="activeTab == 'en' ? 'active' : ''") {{ $t("ui.en") }}
          li.nav-item
            a#cnNewsAdd-tab.nav-link(data-toggle='tab' href='#cnNewsAdd-content' role='tab' aria-controls='cnNewsAdd' aria-selected='false' @click="setTab('cn')" :class="activeTab == 'cn' ? 'active' : ''") {{ $t("ui.cn") }}
          li.nav-item
            a#localNewsAdd-tab.nav-link(data-toggle='tab' href='#localNewsAdd-content' role='tab' aria-controls='localNewsAdd' aria-selected='false' @click="setTab('local')" :class="activeTab == 'local' ? 'active' : ''") {{ $t("ui.local") }}

        #editorcontent.tab-content.tab-bordered
          #enNewsAdd-content.tab-pane(:class="activeTab == 'en' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='enNewsAdd-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.title')").mb-0
                ckeditor(
                  :dirty="$v.en_title.$dirty"
                  :error="$v.en_title.$error"
                  v-model="en_title"
                  :config="enTitleConfig"
                  :disabled="loading"
                  )
                ValidateResult(:value="$v.en_title" :name="$t('ui.title')")
              b-form-group.w-100(:label="$t('ui.preview_body')").mb-0
                b-form-textarea(
                  :dirty="$v.en_preview_body.$dirty"
                  :error="$v.en_preview_body.$error"
                  v-model="en_preview_body"
                  style="height:70px;"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.en_preview_body" :name="$t('ui.preview_body')")
              b-form-group.w-100(:label="$t('ui.full_body')").mb-0
                ckeditor(
                  :dirty="$v.en_body.$dirty"
                  :error="$v.en_body.$error"
                  v-model="en_body"
                  :config="enBodyConfig"
                  :disabled="loading"
                  )
                ValidateResult(:value="$v.en_body" :name="$t('ui.full_body')")
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][7] }) }}
              b-form-group.w-100(:label="$t('ui.image')").mb-0
                b-form-file(
                  :dirty="$v.en_image.$dirty"
                  :error="$v.en_image.$error"
                  v-model.trim.lazy="$v.en_image.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectEn"
                  v-if="enImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }}
                ValidateResult(:value="$v.en_image" :name="$t('ui.en_image')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="removeEnImage()"
                  variant="danger"
                  size="sm"
                  v-if="enImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="enImageSrc != null" :src="enImageSrc")

          #cnNewsAdd-content.tab-pane(:class="activeTab == 'cn' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='cnNewsAdd-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.title')").mb-0
                ckeditor(
                  v-model="cn_title"
                  :config="cnTitleConfig"
                  :disabled="loading"
                  )
              b-form-group.w-100(:label="$t('ui.preview_body')").mb-0
                b-form-textarea(
                  v-model="cn_preview_body"
                  style="height:70px;"
                  :disabled="loading"
                )
              b-form-group.w-100(:label="$t('ui.full_body')").mb-0
                ckeditor(
                  v-model="cn_body"
                  :config="cnBodyConfig"
                  :disabled="loading"
                  )
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][7] }) }}
              b-form-group.w-100(:label="$t('ui.image')").mb-0
                b-form-file(
                  :dirty="$v.cn_image.$dirty"
                  :error="$v.cn_image.$error"
                  v-model.trim.lazy="$v.cn_image.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectCn"
                  v-if="cnImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }}
                ValidateResult(:value="$v.cn_image" :name="$t('ui.cn_image')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="removeCnImage()"
                  variant="danger"
                  size="sm"
                  v-if="cnImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="cnImageSrc != null" :src="cnImageSrc")

          #localNewsAdd-content.tab-pane(:class="activeTab == 'local' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='localNewsAdd-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.title')").mb-0
                //- vue-editor(v-model="content")
                ckeditor(
                  v-model="local_title"
                  :config="localTitleConfig"
                  :disabled="loading"
                  )
              b-form-group.w-100(:label="$t('ui.preview_body')").mb-0
                b-form-textarea(
                  v-model="local_preview_body"
                  style="height:70px;"
                  :disabled="loading"
                )
              b-form-group.w-100(:label="$t('ui.full_body')").mb-0
                //- vue-editor(v-model="content")
                ckeditor(
                  v-model="local_body"
                  :config="localBodyConfig"
                  :disabled="loading"
                  )
              .alert.alert-warning.p-1.mb-2.w-100(v-if="imgSize && imgSize[themeCode]") *{{ $t("message.banner_size_tooltips", { size: imgSize[themeCode][7] }) }}
              b-form-group.w-100(:label="$t('ui.image')").mb-0
                b-form-file(
                  :dirty="$v.local_image.$dirty"
                  :error="$v.local_image.$error"
                  v-model.trim.lazy="$v.local_image.$model"
                  ref="file"
                  accept="image/jpeg, image/png, image/jpg"
                  @change="onSelectLocal"
                  v-if="localImageSrc == null"
                )
                small.form-text.text-muted {{ $t('message.tooltips_upload_size') }}
                ValidateResult(:value="$v.local_image" :name="$t('ui.local_image')")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-times"
                  :text="$t('ui.remove')"
                  type="button"
                  @click="removeLocalImage()"
                  variant="danger"
                  size="sm"
                  v-if="localImageSrc != null"
                  )
                br
                b-img.w-50.h-50(v-if="localImageSrc != null" :src="localImageSrc")

    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue, requiredIf, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CMSBannerCount from "@/library/CMSBannerCount";
import { VueEditor, Quill } from "vue2-editor";
import $ from 'jquery';
const fileSizeValidation = (value, vm) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1048576);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

const validSlugFormat = helpers.regex(
  "validSlugFormat",
  /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/
);


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CMSBannerCount,
    VueEditor
  },
  props: {
    viewType: {
      type: Number
    }
  },
  data() {
    return {
      item_order: 0,
      default_order: true,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      en_title: "",
      en_body: "",
      en_image: null,
      cn_title: "",
      cn_body: "",
      cn_image: null,
      local_title: "",
      local_body: "",
      local_image: null,
      // Enhanced CKEditor configurations - full toolbar options
      enTitleConfig: {
        versionCheck: false,
        height: '100px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        // removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.enTitleEditorInstance = editor
            this.setupEditorSecurity(editor);
          }.bind(this),
        }
      },
      cnTitleConfig: {
        versionCheck: false,
        height: '100px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        // removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.cnTitleEditorInstance = editor
            this.setupEditorSecurity(editor);
          }.bind(this)
        }
      },
      localTitleConfig: {
        versionCheck: false,
        height: '100px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        // removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.localTitleEditorInstance = editor
            this.setupEditorSecurity(editor);
          }.bind(this)
        }
      },
      enBodyConfig: {
        versionCheck: false,
        height: '200px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        // removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.enBodyEditorInstance = editor
            this.setupEditorSecurity(editor);
          }.bind(this)
        }
      },
      cnBodyConfig: {
        versionCheck: false,
        height: '200px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        // removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.cnBodyEditorInstance = editor
            this.setupEditorSecurity(editor);
          }.bind(this)
        }
      },
      localBodyConfig: {
        versionCheck: false,
        height: '200px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog,uploadimage,filebrowser',
        filebrowserUploadUrl: config.uploadEditorImageUrl,
        filebrowserImageUploadUrl: config.uploadEditorImageUrl,
        // removePlugins: 'source,sourcearea',
        on: {
          instanceReady: function (evt) {
            const editor = evt.editor;
            this.localBodyEditorInstance = editor
            this.setupEditorSecurity(editor);
          }.bind(this)
        }
      },
      locale: "",
      en_image_url: "",
      cn_image_url: "",
      local_image_url: "",
      enImageName: "",
      cnImageName: "",
      localImageName: "",
      enImageSrc: null,
      cnImageSrc: null,
      localImageSrc: null,
      slug: "",
      activeTab: "en",
      en_preview_body: "",
      cn_preview_body: "",
      local_preview_body: "",
      enTitleEditorInstance: null,
      enBodyEditorInstance: null,
      cnTitleEditorInstance: null,
      cnBodyEditorInstance: null,
      localTitleEditorInstance: null,
      localBodyEditorInstance: null
    };
  },
  computed: {
    imgSize() {
      return config.bannerDimension;
    },
    themeCode() {
      return this.$store.getters.selectedTheme;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    slug: {
      required,
      validSlugFormat
    },
    default_order: {
      required
    },
    item_order: {
      required : requiredIf(function () {
        return this.default_order == false;
      }),
      minValue(value) {
        if (this.default_order == true) {
          return minValue(0)(value)
        } else {
          return minValue(1)(value)
        }
      }
    },
    en_title: {
      required
    },
    en_body: {
      required
    },
    en_preview_body: {
      required
    },
    en_image: {
      required : requiredIf(function () {
        return this.enImageSrc == null;
      }),
      fileSizeValidation
    },
    cn_image: {
      fileSizeValidation
    },
    local_image: {
      fileSizeValidation
    }
  },
  watch: {
    en_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.enImageSrc = value;
            })
            .catch(() => {
              this.enImageSrc = null;
            });
        } else {
          this.enImageSrc = null;
        }
      }
    },
    cn_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.cnImageSrc = value;
            })
            .catch(() => {
              this.cnImageSrc = null;
            });
        } else {
          this.cnImageSrc = null;
        }
      }
    },
    local_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.localImageSrc = value;
            })
            .catch(() => {
              this.localImageSrc = null;
            });
        } else {
          this.localImageSrc = null;
        }
      }
    }
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    removeEnImage() {
      this.en_image = null;
      this.en_image_url = "";
      this.enImageName = "";
      this.enImageSrc = null;
    },
    removeCnImage() {
      this.cn_image = null;
      this.cn_image_url = "";
      this.cnImageName = "";
      this.cnImageSrc = null;
    },
    removeLocalImage() {
      this.local_image = null;
      this.local_image_url = "";
      this.localImageName = "";
      this.localImageSrc = null;
    },
    onSelectEn(evt) {
      if(evt.target.files.length > 0){
        this.enImageName = evt.target.files[0].name;
        // this.file = file;
      }else{
        return
      }
    },
    onSelectCn(evt) {
      if(evt.target.files.length > 0){
        this.cnImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    onSelectLocal(evt) {
      if(evt.target.files.length > 0){
        this.localImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    async submit() {
      await Promise.all([
        [this.enTitleEditorInstance, 'en_title'],
        [this.cnTitleEditorInstance, 'cn_title'],
        [this.localTitleEditorInstance, 'local_title'],
        [this.enBodyEditorInstance, 'en_body'],
        [this.cnBodyEditorInstance, 'cn_body'],
        [this.localBodyEditorInstance, 'local_body']
      ].map(([editor, field]) => this.syncEditor(editor, field)))

      await this.$nextTick()

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    async syncEditor(editor, field) {
      if (!editor) return

      if (editor.mode === 'source') {
        await new Promise(resolve => {
          editor.once('mode', resolve)
          editor.setMode('wysiwyg')
        })
      }

      this[field] = editor.getData()
    },
    proceed() {
      let url = config.cmsNewsAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        en_title: this.en_title,
        en_full_body: this.en_body,
        en_image_url: this.en_image_url,
        en_preview_body: this.en_preview_body,
        cn_title: this.cn_title,
        cn_full_body: this.cn_body,
        cn_image_url: this.cn_image_url,
        cn_preview_body: this.cn_preview_body,
        local_title: this.local_title,
        local_full_body: this.local_body,
        local_image_url: this.local_image_url,
        local_preview_body: this.local_preview_body,
        default_order: this.default_order,
        item_order: this.default_order == false ? this.item_order : null,
        slug: this.slug
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addNews.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_news", this.feedback.status);
                this.$refs.addNews.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    async uploadEnImage() {
      if (this.enImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.en_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.en_image_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadCnImage() {
      if (this.cnImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.cn_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.cn_image_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadLocalImage() {
      if (this.localImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.local_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.local_image_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async confirmSubmit() {
      const p1 = this.uploadEnImage();
      const p2 = this.uploadCnImage();
      const p3 = this.uploadLocalImage();
      const someResult = await p1;
      const anotherResult = await p2;
      const anotherResult2 = await p3;

      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.activeTab = 'en';
    },
    shown: function() {
      this.enTitleEditorInstance = null;
      this.enBodyEditorInstance = null;
      this.cnTitleEditorInstance = null;
      this.cnBodyEditorInstance = null;
      this.localTitleEditorInstance = null;
      this.localBodyEditorInstance = null;
      this.default_order = true;
      this.item_order = 0;
      this.en_title = "<h5></h5>";
      this.en_body = "";
      this.en_image = null;
      this.cn_title = "<h5></h5>";
      this.cn_body = "";
      this.cn_image = null;
      this.local_title = "<h5></h5>";
      this.local_body = "";
      this.local_image = null;
      this.slug = "";
      this.enImageName = "";
      this.cnImageName = "";
      this.localImageName = "";
      this.en_image_url = ""
      this.cn_image_url = ""
      this.local_image_url = ""
      this.en_preview_body = ""
      this.cn_preview_body = ""
      this.local_preview_body = ""
      this.$v.$reset();
      $("#addNews").find('.modal-content').first().removeAttr('tabindex');
    },
    // Enhanced CKEditor security setup method
    setupEditorSecurity(editor) {
      // Block paste files/base64 images
      editor.on('paste', function (e) {
        if (e.data && e.data.dataTransfer && typeof e.data.dataTransfer.getFiles === 'function') {
          const files = e.data.dataTransfer.getFiles();
          if (files && files.length > 0) {
            e.cancel();
            return;
          }
        }
        if (e.data && e.data.dataValue && e.data.dataValue.indexOf('data:image') !== -1) {
          e.cancel();
        }
      });

      // Block drag & drop files/images
      editor.on('contentDom', function () {
        editor.document.on('drop', function (e) {
          const dataTransfer = e.data.$.dataTransfer;
          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
            e.data.preventDefault(true);
          }
        });
      });

      // Additional security measures
      editor.on('beforeCommandExec', function (evt) {
        const command = evt.data.name;
        // Block potentially dangerous commands
        if (command === 'execCommand' || command === 'insertHtml') {
          // Add additional validation if needed
        }
      });

      if (editor._dialogSecurityHooked) return;
      editor._dialogSecurityHooked = true;

      // Hook dialog definition for upload button override
      editor.on('dialogDefinition', function (ev) {
        const dialogName = ev.data.name;
        const dialogDefinition = ev.data.definition;

        if (dialogName === 'image') {
          const uploadTab = dialogDefinition.getContents('Upload');
          const uploadButton = uploadTab.get('uploadButton');

          // Ensure upload input exists
          if (!uploadTab.get('upload')) {
            uploadTab.add({
              type: 'file',
              id: 'upload',
              label: 'Send it to the Server',
              size: 38,
            });
          }

          uploadButton['for'] = ['Upload', 'upload'];

          // Override upload button click
          uploadButton.onClick = function (evt) {
            const dialog = evt.sender.getDialog();
            const fileInput = dialog.getContentElement('Upload', 'upload').getInputElement().$;
            const file = fileInput.files[0];

            var invalidImage = this.$helpers.checkImgCkEditor(file);
            if (invalidImage)
              return;

            const formData = new FormData();
            formData.append('upload', file);

            fetch(editor.config.filebrowserUploadUrl, {
              method: 'POST',
              body: formData,
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.uploaded === 1) {
                  dialog.getContentElement('info', 'txtUrl').setValue(data.url);
                  dialog.hide();
                } else {
                  const msg = (data.error && data.error.message) || 'Upload failed.';
                  alert(msg);
                  fileInput.value = '';
                }
              })
              .catch((err) => {
                alert('Upload error: ' + err.message);
                fileInput.value = '';
              });
          };
        }
      });

      // Attach validation after the dialog actually appears
      var vm = this;
      editor.on('dialogShow', function (evt) {
        const dialog = evt.data;
        if (dialog.getName() !== 'image') return;

        // Wait for DOM to render
        setTimeout(() => {
          const uploadElement = dialog.getContentElement('Upload', 'upload');
          if (!uploadElement) return;

          const input = uploadElement.getInputElement().$;

          // remove old listener (avoid duplicates)
          input.removeEventListener('change', input._vueFileChangeHandler || (() => {}));

          // attach new listener
          input._vueFileChangeHandler = function () {
            const file = input.files[0];
            if (!file) return;

            var invalidImage = vm.$helpers.checkImgCkEditor(file);
            if (invalidImage) {
              input.value = '';
              return;
            }
          };

          input.addEventListener('change', input._vueFileChangeHandler);
        }, 100);
      });
    }
  }
};
</script>
